import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { forkJoin } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ProjectService } from '../../../../services/project.service';
import { IProject, ITeamMember } from '../../../../interfaces/models/project.model';
import { CommonModule } from '@angular/common';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { DirectionService } from '../../../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
import { CustomAblePipe } from '../../../../pipes/able.pipe';
import { AuthService } from '../../../../services/auth.service';
import { authUser } from '../../../../interfaces/auth';

@Component({
  selector: 'app-team-member',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    RadioButtonModule,
    DropdownModule,
    FormsModule,
    ConfirmPopupModule,
    TooltipModule,
    TranslateModule,
    CustomAblePipe
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './team-member.component.html',
  styleUrl: './team-member.component.scss'
})
export class TeamMemberComponent implements OnInit {
  test = false
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  @ViewChild('employeeCreateForm') employeeCreateForm!: FormGroup;
  @ViewChild('updateTeamMemberForm') updateTeamMemberForm!: FormGroup;
  @ViewChild('updateTeamLeaderForm') updateTeamLeaderForm!: FormGroup;
  
  @Output() teamMembersChanged = new EventEmitter<ITeamMember[]>();
  @Output() teamLeaderChanged = new EventEmitter<any>();
  
  @Input()
  strategyId!: number;

  @Input()
  projectId!: number;

  @Input() set teamMembers(value: ITeamMember[]) {
    if (value && value.length > 0) {
      this._teamMembers = value;
      // Separate team leader from team members
      this.teamLeader = value?.find(tm => tm.is_in_charge) || {} as any;
      this.filteredTeamMembers = value?.filter(tm => !tm.is_in_charge) || [];
    } else {
      // Try to load from sessionStorage when no data is passed
      this.loadFromSessionStorage();
    }
  }
  get teamMembers() {
    return this._teamMembers;
  }
  
  teamLeader: any = {};
  _ProjectsRelations!: any;
  @Input() set ProjectsRelations(value: any) {
    console.log("team member ", value);
    this._ProjectsRelations = value;
    // Prepare units options whenever ProjectsRelations changes
    if (value) {
      this.prepareUnitsOptions();
    }
  }
  get ProjectsRelations() {
    return this._ProjectsRelations;
  }
  _teamMembers = [] as ITeamMember[];
  isVisibleUpdateTeamMember = false;
  isVisibleUpdateTeamLeader = false;
  _empolyeeSearchTerm = ''

  set empolyeeSearchTerm(value: string) {
    this._empolyeeSearchTerm = value;
    this.search()
  }
  get empolyeeSearchTerm() {
    return this._empolyeeSearchTerm;
  }
  isVisiblEmployeeModal = false;
  isVisiblEmployeeUpdateModal = false;
  isCreateEmployeeSubmitted = false;
  // teamMembers!: ITeamMember[];
  filteredTeamMembers!: ITeamMember[];

  selectedTeamMember = {} as ITeamMember;
  dir!: 'rtl' | 'ltr';
  user!: authUser;
  isupdateTeamMemberSubmitted = false;
  selectedUnit: string | null = null;
  unitsOptions: any[] = [];

  _project!: IProject;
  @Input() set project(project: IProject) {
    console.log("project props", project);
    this._project = project;
  }
  get project() {
    return this._project;
  }

  constructor(private projectService: ProjectService,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private directionService: DirectionService,
    private authService: AuthService,
    private http: HttpClient
  ) {
  }


  ngOnInit(): void {
    // For existing projects, load from API
    if (this.projectId && this.projectId > 0) {
      this.projectService.ListTeamMembers(this.strategyId, this.projectId).subscribe((teamMembers) => {
        this._teamMembers = teamMembers || [];
        // Separate team leader from team members
        this.teamLeader = teamMembers?.find(tm => tm.is_in_charge) || {} as any;
        this.filteredTeamMembers = teamMembers?.filter(tm => !tm.is_in_charge) || [];
        
        // Load team units AFTER team members are loaded
        this.loadTeamUnits();
      })
    } else {
      // For new projects, load from sessionStorage
      this.loadFromSessionStorage();
    }

    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
    this.authService.authBufferSub$.subscribe(user => {
      this.user = user || {} as authUser;
    })
  }

  loadFromSessionStorage() {
    const storageKey = `temp_project_team_members_${this.strategyId}`;
    const storedData = sessionStorage.getItem(storageKey);
    
    if (storedData) {
      try {
        const data = JSON.parse(storedData);
        this._teamMembers = data.teamMembers || [];
        this.teamLeader = data.teamLeader || {} as any;
        this.filteredTeamMembers = this._teamMembers.filter(tm => !tm.is_in_charge) || [];
        console.log('Loaded team data from sessionStorage:', this._teamMembers);
      } catch (e) {
        console.error('Error parsing sessionStorage:', e);
        this._teamMembers = [];
        this.filteredTeamMembers = [];
      }
    }
  }

  saveToSessionStorage() {
    const storageKey = `temp_project_team_members_${this.strategyId}`;
    const data = {
      teamMembers: this._teamMembers,
      teamLeader: this.teamLeader
    };
    sessionStorage.setItem(storageKey, JSON.stringify(data));
    console.log('Saved team data to sessionStorage');
  }

  loadTeamUnits() {
    // Only load if project exists (projectId > 0)
    if (this.projectId && this.projectId > 0) {
      this.projectService.getTeamUnits(this.strategyId, this.projectId).subscribe({
        next: (response: any) => {
          console.log('Team units response:', response);
          const teamUnits = response?.data?.teamUnits || [];
          console.log('Team units loaded:', teamUnits);
          
          // Merge team units with team members
          this._teamMembers = [...this._teamMembers, ...teamUnits];
          this.filteredTeamMembers = [...this.filteredTeamMembers, ...teamUnits];
          
          console.log('All team members after merge:', this._teamMembers);
        },
        error: (err) => {
          console.error('Error loading team units:', err);
        }
      });
    }
  }

  prepareUnitsOptions() {
    if (!this.ProjectsRelations) {
      console.log('ProjectsRelations not available yet');
      return;
    }

    const departments = (this.ProjectsRelations?.departments || []).map((dept: any) => ({
      name: dept.name,
      value: `department-${dept.id}`,
      id: dept.id,
      type: 'department'
    }));

    const sections = (this.ProjectsRelations?.sections || []).map((section: any) => ({
      name: section.name,
      value: `section-${section.id}`,
      id: section.id,
      type: 'section'
    }));

    this.unitsOptions = [...departments, ...sections];
    if (!this.unitsOptions.length) {
      this.loadHierarchyUnits();
    }
  }

  openAddMemberModal() {
    this.isVisiblEmployeeModal = true;
    if (!this.unitsOptions?.length) {
      this.prepareUnitsOptions();
      this.loadHierarchyUnits();
    }
  }

  private loadHierarchyUnits() {
    forkJoin({
      departments: this.http.get<any>(environment.domain + 'hierarchy/departments'),
      sections: this.http.get<any>(environment.domain + 'hierarchy/sections')
    }).subscribe({
      next: (response) => {
        const departments = response.departments?.data?.departments || response.departments?.departments || [];
        const sections = response.sections?.data?.sections || response.sections?.sections || [];
        this.unitsOptions = [
          ...departments.map((dept: any) => ({
            name: dept.name,
            value: `department-${dept.id}`,
            id: dept.id,
            type: 'department'
          })),
          ...sections.map((section: any) => ({
            name: section.name,
            value: `section-${section.id}`,
            id: section.id,
            type: 'section'
          }))
        ];
      },
      error: (err) => {
        console.error('Error loading hierarchy units:', err);
      }
    });
  }

  closeUpdateTeamMemberModal() {
    this.isVisibleUpdateTeamMember = false;
  }

  openUpdateTeamMemberModal(id: number) {
    this.selectedTeamMember = { ...this._teamMembers.find(x => x.id == id) } as ITeamMember || {} as ITeamMember;
    this.isVisibleUpdateTeamMember = true;
  }

  closeUpdateTeamLeaderModal() {
    this.isVisibleUpdateTeamLeader = false;
  }

  openUpdateTeamLeaderModal() {
    this.isVisibleUpdateTeamLeader = true;
  }

  updateTeamLeader() {
    if (this.teamLeader.activity) {
      // Save to sessionStorage if new project
      if (!this.projectId || this.projectId === 0) {
        this.saveToSessionStorage();
      }
      
      // Emit changes to parent
      this.teamLeaderChanged.emit(this.teamLeader);
      
      this.isVisibleUpdateTeamLeader = false;
      this.toastr.success(
        this.dir == 'rtl' ? 'تم تحديث قائد الفريق بنجاح' : 'Team leader updated successfully',
        this.dir == 'rtl' ? 'نجاح' : 'Success'
      );
    }
  }
  closeEmployeeModal() {
    this.isVisiblEmployeeModal = false;
  }
  confirmTeamMemberDelete(event: Event, id: number) {
    const target = event.target as HTMLElement;
    const member = this._teamMembers.find(x => x.id == id);
    
    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? 'هل تريد تأكيد المسح؟' : 'Do you want to confirm the deletion?',
      accept: () => {
        // Check if it's a unit or employee
        if (member?.unit_type) {
          // Delete team unit via API
          this.projectService.deleteTeamUnit(this.strategyId, this.projectId, id).subscribe({
            next: (response: any) => {
              this._teamMembers = this._teamMembers.filter(x => x.id != id);
              this.filteredTeamMembers = this.filteredTeamMembers.filter(x => x.id != id);
              
              // Save to sessionStorage if new project
              if (!this.projectId || this.projectId === 0) {
                this.saveToSessionStorage();
              }
              
              // Emit changes to parent
              this.teamMembersChanged.emit(this._teamMembers);
              
              this.toastr.success(
                this.dir == 'rtl' ? 'تم المسح' : 'Deleted successfully',
                this.dir == 'rtl' ? 'عملية ناجحة' : 'Success'
              );
            },
            error: (err) => {
              this.toastr.error(
                this.dir == 'rtl' ? 'فشل في المسح' : 'Failed to delete',
                this.dir == 'rtl' ? 'خطأ' : 'Error'
              );
            }
          });
        } else {
          // Delete team member (employee) via API
          this.projectService.deleteTeamMember(this.strategyId, this.projectId, id).subscribe({
            next: (response: any) => {
              this._teamMembers = this._teamMembers.filter(x => x.id != id);
              this.filteredTeamMembers = this.filteredTeamMembers.filter(x => x.id != id);
              
              // Save to sessionStorage if new project
              if (!this.projectId || this.projectId === 0) {
                this.saveToSessionStorage();
              }
              
              this.toastr.success(
                this.dir == 'rtl' ? 'تم المسح' : 'Deleted successfully',
                this.dir == 'rtl' ? 'عملية ناجحة' : 'Success'
              );
            }
          });
        }
      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "The deletion has been canceled.", this.dir == 'rtl' ? 'الغاء' : 'Canceled');
      }
    });
  }
  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }
  search() {
    if (!this.empolyeeSearchTerm || !this.empolyeeSearchTerm.trim()) {
      this.filteredTeamMembers = this._teamMembers?.filter(tm => !tm.is_in_charge) || [];
      return;
    }
    const allMembers = this._teamMembers?.filter(tm => !tm.is_in_charge) || [];
    this.filteredTeamMembers = allMembers.filter(({ name }) => {
      return name.includes(this.empolyeeSearchTerm)
    });
  }
  createEmployee() {
    this.isCreateEmployeeSubmitted = true;

    if (this.employeeCreateForm.valid && this.selectedUnit) {
      const [unitType, unitId] = this.selectedUnit.split('-');
      const unitData = this.unitsOptions.find(u => u.value === this.selectedUnit);

      const createData = {
        unit_type: unitType,
        unit_id: parseInt(unitId),
        activity: this.employeeCreateForm.value['activity']
      };

      // Check if project exists (if not, just add to local array)
      if (this.projectId && this.projectId > 0) {
        // Save to backend
        this.projectService.createTeamUnit(this.strategyId, this.projectId, createData).subscribe({
          next: (response: any) => {
            const newTeamMember: any = {
              id: response.data.entity.id,
              name: unitData.name,
              unit_type: unitType,
              unit_id: parseInt(unitId),
              activity: this.employeeCreateForm.value['activity'],
              is_primary_connection: false,
              is_in_charge: false,
              department_name: '',
              job_title: '',
              user_id: 0
            };

            this._teamMembers.push(newTeamMember);
            this.filteredTeamMembers = [...this._teamMembers.filter(tm => !tm.is_in_charge)];
            
            // Emit changes to parent
            this.teamMembersChanged.emit(this._teamMembers);

            this.toastr.success(
              this.dir == 'rtl' ? 'تمت الإضافة بنجاح' : 'Added successfully',
              this.dir == 'rtl' ? 'نجاح' : 'Success'
            );

            this.employeeCreateForm.reset({
              unit_id: null,
              activity: ''
            });
            this.selectedUnit = null;
            this.isCreateEmployeeSubmitted = false;
            this.isVisiblEmployeeModal = false;
          },
          error: (err) => {
            this.toastr.error(
              this.dir == 'rtl' ? 'فشل في الإضافة' : 'Failed to add',
              this.dir == 'rtl' ? 'خطأ' : 'Error'
            );
          }
        });
      } else {
        // Project not created yet - add to local array only
        const newTeamMember: any = {
          id: Date.now(), // temporary ID
          name: unitData.name,
          unit_type: unitType,
          unit_id: parseInt(unitId),
          activity: this.employeeCreateForm.value['activity'],
          is_primary_connection: false,
          is_in_charge: false,
          department_name: '',
          job_title: '',
          user_id: 0
        };

        this._teamMembers.push(newTeamMember);
        this.filteredTeamMembers = [...this._teamMembers.filter(tm => !tm.is_in_charge)];
        
        // Save to sessionStorage for new projects
        this.saveToSessionStorage();
        
        // Emit changes to parent
        this.teamMembersChanged.emit(this._teamMembers);

        this.toastr.success(
          this.dir == 'rtl' ? 'تمت الإضافة بنجاح (سيتم الحفظ عند إنشاء المبادرة)' : 'Added successfully (will be saved when project is created)',
          this.dir == 'rtl' ? 'نجاح' : 'Success'
        );

        this.employeeCreateForm.reset({
          unit_id: null,
          activity: ''
        });
        this.selectedUnit = null;
        this.isCreateEmployeeSubmitted = false;
        this.isVisiblEmployeeModal = false;
      }

    } else {
      this.toastr.error(this.dir == 'rtl' ? 'يرجى مراجعة وإكمال البيانات' : 'Please check the data and complete it')
    }
  }

  updateTeamMember() {
    this.isupdateTeamMemberSubmitted = true;
    
    if (this.updateTeamMemberForm.valid) {
      const updateData = {
        activity: this.updateTeamMemberForm.value['activity']
      };

      // Check if it's a unit (department/section) or employee
      if (this.selectedTeamMember.unit_type) {
        // Update team unit via API
        this.projectService.updateTeamUnit(this.strategyId, this.projectId, this.selectedTeamMember.id, updateData).subscribe({
          next: (response: any) => {
            const finalTeamMembers = this._teamMembers.map((teamMember: any) => {
              if (teamMember.id == this.selectedTeamMember.id) {
                return {
                  ...teamMember,
                  activity: updateData.activity
                }
              } else {
                return teamMember;
              }
            })

            this._teamMembers = structuredClone(finalTeamMembers);
            this.filteredTeamMembers = finalTeamMembers.filter(tm => !tm.is_in_charge);
            
            // Save to sessionStorage if new project
            if (!this.projectId || this.projectId === 0) {
              this.saveToSessionStorage();
            }
            
            // Emit changes to parent
            this.teamMembersChanged.emit(this._teamMembers);
            
            this.isVisibleUpdateTeamMember = false;

            this.toastr.success(
              this.dir == 'rtl' ? 'تم التعديل بنجاح' : 'Updated successfully',
              this.dir == 'rtl' ? 'نجاح' : 'Success'
            )
          },
          error: (err) => {
            this.toastr.error(
              this.dir == 'rtl' ? 'فشل في التعديل' : 'Failed to update',
              this.dir == 'rtl' ? 'خطأ' : 'Error'
            );
          }
        });
      } else {
        // Update team member (employee) via API
        this.projectService.updateTeamMember(this.strategyId, this.projectId, this.selectedTeamMember.id, {
          user_id: this.selectedTeamMember.user_id,
          activity: updateData.activity,
          is_primary_connection: this.selectedTeamMember.is_primary_connection
        }).subscribe({
          next: (response: any) => {
            const finalTeamMembers = this._teamMembers.map((teamMember: any) => {
              if (teamMember.id == this.selectedTeamMember.id) {
                return {
                  ...teamMember,
                  activity: updateData.activity
                }
              } else {
                return teamMember;
              }
            })

            this._teamMembers = structuredClone(finalTeamMembers);
            this.filteredTeamMembers = finalTeamMembers.filter(tm => !tm.is_in_charge);
            
            // Save to sessionStorage if new project
            if (!this.projectId || this.projectId === 0) {
              this.saveToSessionStorage();
            }
            
            this.isVisibleUpdateTeamMember = false;

            this.toastr.success(
              this.dir == 'rtl' ? 'تم التعديل بنجاح' : 'Updated successfully',
              this.dir == 'rtl' ? 'نجاح' : 'Success'
            )
          }
        });
      }
    }
  }
}









